import React from 'react';

import {makeToolTipUrl} from "utils/DBUtils";

export const UGCHeadlineToolTip = (props) => (
  <div>
    The title of the break, featured on top.
    <br/>
    <img src={makeToolTipUrl('ugc/1.CMS-UGC-headline.png')} width="100%"/>
  </div>
);

export const UGCIntroToolTip = (props) => (
  <div>
    Copy overview of the break.
    <br/>
    <img src={makeToolTipUrl('ugc/2.CMS-UGC-intro.png')} width="100%"/>
  </div>
);

export const UGCExampleImageToolTip = (props) => (
  <div>
    An example of a completed UGC frame.
    <br/>
    <img src={makeToolTipUrl('ugc/3.CMS-UGC-example-img.png')} width="100%"/>
  </div>
);

export const UGCInternalNameToolTip = (props) => (
  <div>
    This is used for identifying submissions in the Moderation Gallery.
  </div>
);

export const UGCStartButtonTextToolTip = (props) => (
  <div>
    Text prompting reader to begin the UGC.  Default is "Get Started"
    <br/>
    <img src={makeToolTipUrl('ugc/4.CMS-UGC-button-text.png')} width="100%"/>
  </div>
);

export const UGCDefaultAllowPhotoUploadToolTip = (props) => (
  <div>
    If yes, the reader will be allowed to upload a photo for each frame.
    <br/>
    <img src={makeToolTipUrl('ugc/5.CMS-UGC-allow-photo.png')} width="100%"/>
  </div>
);

export const UGCDefaultAllowDrawingToolTip = (props) => (
  <div>
    If yes, the reader will be allowed to draw or color on each frame. These images must be transparent PNGs.
    <br/>
    <img src={makeToolTipUrl('ugc/6.CMS-UGC-allow-drawing.png')} width="100%"/>
  </div>
);

export const UGCDefaultAllowTextToolTip = (props) => (
  <div>
    If yes, the reader will be allowed to add text to the UGC on each frame.
    <br/>
    <img src={makeToolTipUrl('ugc/7.CMS-UGC-allow-text.png')} width="100%"/>
  </div>
);

export const UGCFontToolTip = (props) => (
  <div>
    The font of the text in the UGC.  Default is Lato.
  </div>
);

export const UGCFontColorToolTip = (props) => (
  <div>
    The color of the text in the UGC.  Default is black.
  </div>
);

export const UGCCharacterLimitToolTip = (props) => (
  <div>
    Maximum amount of characters that can be used in this field.  This will vary based on font selection.
  </div>
);

export const UGCTextLineHeightToolTip = (props) => (
  <div>
    The vertical space in between the text lines. Default is 1.
  </div>
);

export const UGCTextThicknessToolTip = (props) => (
  <div>
    The weight fo the text: Thin, Medium, Bold.
  </div>
);

export const UGCHasStrokeToolTip = (props) => (
  <div>
    If yes, an outline will appear on the outside of the text.
  </div>
);

export const UGCTextPositionToolTip = (props) => (
  <div>
    The location/alignment of the UGC text.
    <br/>
    <img src={makeToolTipUrl('ugc/8.CMS-UGC-text-position.png')} width="100%"/>
  </div>
);

export const UGCShowGalleryToolTip = (props) => (
  <div>
    If yes, a gallery of all readers' submissions will be visible.
    <br/>
    <img src={makeToolTipUrl('ugc/9.CMS-UGC-show-gallery.png')} width="100%"/>
  </div>
);

export const UGCInstructionHeadlineToolTip = (props) => (
  <div>
    The title of the instruction.
    <br/>
    <img src={makeToolTipUrl('ugc/10.CMS-UGC-instruction-headline.png')} width="100%"/>
  </div>
);

export const UGCInstructionDescriptionToolTip = (props) => (
  <div>
    Extra copy for the instructions to elaborate or add PIZAZZ.
    <br/>
    <img src={makeToolTipUrl('ugc/11.CMS-UGC-instruction-description.png')} width="100%"/>
  </div>
);

export const UGCFramesHeadlineToolTip = (props) => (
  <div>
    The title of the interaction page, featured on top.
    <br/>
    <img src={makeToolTipUrl('ugc/12.CMS-UGC-headline.png')} width="100%"/>
  </div>
);

export const UGCFramesIntroToolTip = (props) => (
  <div>
    Extra text field on the Interaction Page of this break that appears below the headline.
    <br/>
    <img src={makeToolTipUrl('ugc/13.CMS-UGC-intro.png')} width="100%"/>
  </div>
);

export const UGCFramesButtonTextToolTip = (props) => (
  <div>
    Copy prompting the reader to complete the UGC. Defaulted with "Save"
    <br/>
    <img src={makeToolTipUrl('ugc/14.CMS-UGC-button-text.png')} width="100%"/>
  </div>
);

export const UGCFramesBackgroundColorToolTip = (props) => (
  <div>
    The color behind the frame.  If the reader does not fill in the entire content area this color will show through.
    <br/>
    <img src={makeToolTipUrl('ugc/15.CMS-UGC-frame-bkgd-color.png')} width="100%"/>
  </div>
);

export const UGCShowCustomizedConsentToolTip = (props) => (
  <div>
    If yes, the reader will see a consent checkbox.
    <br/>
    <img src={makeToolTipUrl('ugc/16.CMS-UGC-consent-checkbox.png')} width="100%"/>
  </div>
);

export const UGCCustomizedConsentRequiredToolTip = (props) => (
  <div>
    If yes, the reader will have to select the consent checkbox in order to continue.
    <br/>
    <img src={makeToolTipUrl('ugc/17.CMS-UGC-consent-checkbox-required.png')} width="100%"/>
  </div>
);

export const UGCCustomizedConsentTextToolTip = (props) => (
  <div>
    Custom copy informing readers of what they are consenting to.
    <br/>
    <img src={makeToolTipUrl('ugc/18.CMS-UGC-consent-text.png')} width="100%"/>
  </div>
);

export const UGCRequestUserEmailToolTip = (props) => (
  <div>
    If yes, the reader has the option to include their email in order to complete the break.
    <br/>
    <img src={makeToolTipUrl('ugc/19.CMS-UGC-request-email.png')} width="100%"/>
  </div>
);

export const UGCUserEmailRequiredToolTip = (props) => (
  <div>
    If yes, the reader must include their email in order to complete the break or step.
  </div>
);

export const UGCUserEmailTextToolTip = (props) => (
  <div>
    The message to the reader explaining why an email is requested/required in this break.
    <br/>
    <img src={makeToolTipUrl('ugc/20.CMS-UGC-request-email-text.png')} width="100%"/>
  </div>
);

export const UGCFrameImageToolTip = (props) => (
  <div>
    Customized images the reader will select from. If using drawing, these images must be transparent PNGs.
    <br/>
    <img src={makeToolTipUrl('ugc/21.CMS-UGC-frame-img.png')} width="100%"/>
  </div>
);

export const UGCFrameAllowUploadToolTip = (props) => (
  <div>
    Override the selection in the general section for just this frame.
  </div>
);

export const UGCFrameAllowDrawingToolTip = (props) => (
  <div>
    Override the selection in the general section for just this frame.  Image must be a transparent PNG.
  </div>
);

export const UGCFrameBackgroundColorToolTip = (props) => (
  <div>
    The color that is behind this frame, this will override the selection in the general section for this frame item.
  </div>
);

export const UGCFrameTextColorToolTip = (props) => (
  <div>
    The color of the text in the UGC, this will override the selection in the general section for this frame item.
  </div>
);

export const UGCSubmissionHeadlineToolTip = (props) => (
  <div>
    The title of the submission share page, featured on top.
    <br/>
    <img src={makeToolTipUrl('ugc/22.CMS-UGC-submission-headline.png')} width="100%"/>
  </div>
);

export const UGCSubmissionIntroToolTip = (props) => (
  <div>
    Extra text field on the submission share page of this break that appears below the headline.
    <br/>
    <img src={makeToolTipUrl('ugc/23.CMS-UGC-submission-intro.png')} width="100%"/>
  </div>
);

export const UGCGalleryHeadlineToolTip = (props) => (
  <div>
    The title of the gallery page
    <br/>
    <img src={makeToolTipUrl('ugc/24.CMS-UGC-gallery-headline.png')} width="100%"/>
  </div>
);

export const UGCGalleryDescriptionToolTip = (props) => (
  <div>
    Extra text field on the gallery page of this break that appears below the headline
    <br/>
    <img src={makeToolTipUrl('ugc/25.CMS-UGC-gallery-desc.png')} width="100%"/>
  </div>
);

export const UGCGalleryButtonTextToolTip = (props) => (
  <div>
    The label for the button to enter the gallery page.  Default is "Go to Gallery".
    <br/>
    <img src={makeToolTipUrl('ugc/26.CMS-UGC-gallery-button-text.png')} width="100%"/>
  </div>
);

export const UGCGalleryShowSharingToolTip = (props) => (
  <div>
    If yes, any image in the gallery can be selected and shared.
  </div>
);

export const UGCModerateGalleryToolTip = (props) => (
  <div>
    If yes, readers submissions will have to be reviewed and approved in the "UGC Submission" section of Beaker before appearing in the gallery.
  </div>
);



// WEBPACK FOOTER //
// ./public/components/break/tooltips/ugc-tool-tips.jsx